import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { useParams, useHistory } from "react-router-dom";
import { path, domain } from "../../config/enviroment";
import useView from "../../hooks/useView";
import { Button, withStyles, InputAdornment } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import InfoIcon from "@material-ui/icons/Info";
import { v4 as uuid } from "uuid";
import Checkbox from "../../components/CheckBox";
import { termsConditions } from "../../redux/actions/termsActions";
import { CartPaymentButton } from "../../components/CartTotalSummary/style";
import Spinner from "../../components/Spinner";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import {
	handleSearchBuyer,
	handleLoadingInfo,
	handleResetDetails
} from "../../redux/actions/shippingDetailsActions";

import {
	SpanOne,
	SpanTwo,
	LoadContainer,
	DivForSpan1,
	DetailsTextArea,
	SecondSelectForm,
	FirstSelectForm,
	PhoneInput,
	SecondDivForm,
	SecondParragraph,
	ContainerInputEmail,
	MainHeadingForm,
	NameInput,
	FormContainer,
	TitleSummaryCart,
	StyledTextField,
	ContainerAuthorize,
	ContainerNote,
	ReturnLinkContainer,
	AddresInfoContainer,
} from "./style";

import "./style.css";
import { handleIdentifyShoppingCart } from "../../redux/actions/shoppingCartActions";
import {
	handleGetCities,
	handleGetCountries,
	handleGetCitiesAveonline,
	setRoute,
} from "../../redux/actions";
import {
	handleLoadDepartaments,
	handleLoadCities,
	handleOnchangeDefaultCity,
	handleToggleCityChangeModalAlert,
} from "../../redux/actions";
import { formatNameCity } from "../../utils/formatData";
import { AddMoreProducts } from "../../components/CartTotalSummary";
import { language } from "../../utils/language";
import useDocumentTypes from "../../hooks/useDocumentTypes";


const TIPOS_VIA = (lang: Record<string, string>) => [
	{ value: "", label: lang["inputSelect"] },
	{ value: "Carrera", label: lang["aveRoadCarrera"] },
	{ value: "Calle", label: lang["aveRoadStreet"] },
	{ value: "Avenida", label: lang["aveRoadAvenue"] },
	{ value: "Transversal", label: lang["aveRoadTransverse"] },
	{ value: "Diagonal", label: lang["aveRoadDiagonal"] },
	{ value: "Circular", label: lang["aveRoadCircular"] },
	{ value: "Otros", label: lang["aveRoadOther"] },
];

const TIPOS_VIVIENDA = (lang: Record<string, string>) => [
	{ value: "", label: lang["inputSelect"] },
	{ value: "Casa", label: lang["aveResidenceHouse"] },
	{ value: "Apartamento", label: lang["aveResidenceApartment"] },
	{ value: "Unidad residencial", label: lang["aveResidenceResidentialUnit"] },
	{ value: "Edificio", label: lang["aveResidenceBuilding"] },
	{ value: "Conjunto cerrado", label: lang["aveResidenceGatedCommunity"] },
	{ value: "Oficina", label: lang["aveResidenceOffice"] },
	{ value: "Otro", label: lang["aveResidenceOther"] },
];

type AnddressInfoProps = {
	color: string;
	isValidForm: boolean;
	successInfo: boolean;
	register: any;
	handleSubmit: any;
	errors: any;
	loadClient: boolean;
	emailClient: string;
	setLoadClient: any;
	setEmailClient: any;
	trigger?: (a?: string) => any;
	getFormValues: any;
	nextStep?: () => any;
	previousStep?: () => any;
	setCityName: any;
	setCountryName: any;
	catalogueId: string;
	setValue: any;
	showModal?: boolean;
	isAveonlineIntegration: boolean;
};

const AddressInfoAveonline: FunctionComponent<AnddressInfoProps> = ({
	color,
	getFormValues,
	register,
	handleSubmit,
	errors,
	trigger = () => {},
	loadClient,
	emailClient,
	setLoadClient,
	catalogueId,
	setEmailClient,
	nextStep = () => {},
	previousStep = () => {},
	setCityName,
	setCountryName,
	setValue,
	showModal = false,
	isAveonlineIntegration,
}) => {
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const cityState: any = useSelector((state: RootState) => state.city);
	const countryState: any = useSelector((state: RootState) => state.country);
	const shoppingCartState: ShoppingCartStateType = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const shippingDetailsState: any = useSelector(
		(state: RootState) => state.shippingDetails
	);
	const aveonlineState: any = useSelector(
		(state: RootState) => state.aveonline
	);
	const dispatch = useDispatch();
	const { idCart }: any = useParams();
	const { width } = useView();
	const [colorEmptyErrors, setColorEmptyErrors] = useState("#c4c4c4");
	const [productHasProvider, setProductHasProvider] = useState(false);
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const { documentTypes } = useDocumentTypes();

	const labelFontSize = width > 1200 ? "16px" : width > 992 ? "14px" : "14px";

	const labelStyle: React.CSSProperties = {
		display: "block",
		fontSize: labelFontSize,
		fontFamily: "'Segoe UI', 'Open Sans', Roboto, sans-serif",
		color: "#000",
		marginBottom: "5px",
		fontWeight: 600,
		fontStyle: "normal",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	};

	const inputStyle: React.CSSProperties = {
		boxSizing: "border-box",
		height: "46px",
	};

	const onSubmit = () => {
		setHasSubmitted(true);
	};
	let isMobile = false;
	if (width < 992) {
		isMobile = true;
	}
	const history = useHistory();

	const StyledButton = withStyles({
		root: {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			borderTopRightRadius: 10,
			borderBottomRightRadius: 10,
			display: "block !important",
			height: "46px",
			background: homeState.color,
			color: "#fff",
			fontWeight: 600,
			textTransform: "capitalize",
		},
	})(Button);

	const handleNameInput = (e: any) => {
		let patt = new RegExp(/^[A-Za-z áéíóú]+$/i);
		let res = patt.test(e.key);
		if (!res) {
			e.preventDefault();
		}
	};

	const handleDocumentInput = (e: any) => {
		const isNIT = tipoDocumento === 'NIT';
		const patt = isNIT ? /^([0-9-])$/ : /^([0-9])$/;
		if (!patt.test(e.key)) {
			if ([8, 46, 37, 39].includes(e.keyCode)) return;
			e.preventDefault();
		}
	};

	const handlePhoneInput = (e: any) => {
		let patt = new RegExp(/^([0-9]*)$/i);
		let res = patt.test(e.key);
		if (!res) {
			if (
				e.keyCode === 8 ||
				e.keyCode === 46 ||
				e.keyCode === 37 ||
				e.keyCode === 39
			) {
				return;
			}
			e.preventDefault();
		}
	};

	useEffect(() => {
		if (!shippingDetailsState.infoCompleted) {
			if (
				cityState.cities.length === 0 ||
				countryState.countries.length === 0
			) {
				dispatch(handleGetCountries(path));
				dispatch(handleGetCities(path));
			}
		} else {
			setSelectedCountry(shippingDetailsState.country);
			setSelectCity({
				codigoDane: shippingDetailsState.codeDane,
				nombre: shippingDetailsState.city,
				departamento: shippingDetailsState.departament,
			});
			setSelectedDepartament(shippingDetailsState.departament);
		}
		dispatch(
			setRoute({
				route: "/",
				routeName: language[homeState.default_language]["shoppingCart"],
			})
		);
	}, [dispatch]);

	useEffect(() => {
		if (shoppingCartState.id !== 0 || idCart !== 0) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/${idCart}`
			);
		} else if (shoppingCartState.id === 0 && idCart.toStrign().length > 1) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/empty`
			);
		}
	}, [homeState.catalogueName, idCart, shoppingCartState.id]);

	let countries = useRef<any>();
	let departaments = useRef<any>();
	let cities = useRef<any>();

	const [selectCity, setSelectCity] = useState({
		codigoDane: 0,
		nombre: "",
		departamento: language[homeState.default_language]["province"],
	});
	const [selectedDepartament, setSelectedDepartament] = useState(
		language[homeState.default_language]["province"]
	);
	const [selectedCountry, setSelectedCountry] = useState(
		shippingDetailsState.country
	);

	const [selecDepartament, setSelecDepartament] = useState([]);
	const [selectCountry, setSelectCountry] = useState([]);
	const [selCity, setSelCity] = useState([]);
	const [alertShipping, setAlertShipping] = useState(false);
	const [tipoDocumento, setTipoDocumento] = useState('');

	const changeCity = (codigoDane: any) => {
		if (productHasProvider && codigoDane != selectCity.codigoDane) {
			const city = elogisticaState.cities.find(
				(item: any) => item.codigo_dane === codigoDane
			);
			if (city !== undefined) {
				setSelectCity({ ...city, codigoDane: city.codigo_dane });
			} else {
				setSelectCity({
					codigoDane: 0,
					nombre: language[homeState.default_language]["city"],
					departamento: language[homeState.default_language]["province"],
				});
			}
		} else if (!productHasProvider) {
			const city = cityState.cities.find(
				(item: any) => item.dane === codigoDane
			);
			if (city) {
				setSelectCity({
					...city,
					codigoDane: city.dane,
					codigo_dane: city.dane,
					nombre: city.name,
					departamento: city.departmentName,
				});
			} else {
				setSelectCity({
					codigoDane: 0,
					nombre: language[homeState.default_language]["city"],
					departamento: language[homeState.default_language]["province"],
				});
			}
		}
	};

	useEffect(() => {
		if (aveonlineState.cities && aveonlineState.cities.length > 0) {
			const aveonlineCityOptions = [
				<option key="aveonline-city-default" value="">
					{language[homeState.default_language]["inputSelect"]}
				</option>,
				...aveonlineState.cities.map((city: any) => (
					<option key={`aveonline-city-${city.id}`} value={city.nombre}>
						{formatNameCity(city.nombre)}
					</option>
				))
			];
			setSelCity(aveonlineCityOptions as any);

			if (selectCity.nombre && selectCity.nombre !== "" && selectCity.nombre !== language[homeState.default_language]["inputSelect"]) {
				const matchedCity = aveonlineState.cities.find(
					(city: any) => city.nombre.toLowerCase() === selectCity.nombre.toLowerCase()
				);
				if (matchedCity) {
					setSelectCity({
						codigoDane: matchedCity.codigoDANE,
						nombre: matchedCity.nombre,
						departamento: selectedDepartament,
					});
					setCityName(formatNameCity(matchedCity.nombre));
					setValue("cityDane", matchedCity.codigoDANE);
				}
			}
		}
	}, [aveonlineState.cities, homeState.default_language]);

	useEffect(() => {
		loadData();
		if (!shippingDetailsState.isAveonline) {
			setSelectedDepartament(
				shippingDetailsState.departament !== ""
					? shippingDetailsState.departament
					: formatNameCity(elogisticaState.selectedCity.departamento)
			);
			changeCity(
				shippingDetailsState.codeDane !== ""
					? shippingDetailsState.codeDane
					: elogisticaState.selectedCity.codigoDane
			);
		}
	}, [elogisticaState.departaments, elogisticaState.cities]);

	useEffect(() => {
		if (selectCity.codigoDane !== 0 && productHasProvider) {
			setSelectedDepartament(
				formatNameCity(elogisticaState.selectedCity.departamento)
			);
			if (!alertShipping) {
				changeCity(elogisticaState.selectedCity.codigoDane);
			}
			setAlertShipping(false);
			if (
				!elogisticaState.CityChangeModalAlert &&
				selectCity.codigoDane !== elogisticaState.selectedCity.codigoDane
			) {
				dispatch(handleToggleCityChangeModalAlert());
			}
		} else if (productHasProvider) {
			changeCity(elogisticaState.selectedCity.codigoDane);
		}
	}, [elogisticaState.selectedCity.codigoDane, productHasProvider]);

	useEffect(() => {
		if (
			productHasProvider &&
			selectCity.codigoDane !== 0 &&
			elogisticaState.selectedCity.codigoDane !== selectCity.codigoDane
		) {
			dispatch(handleOnchangeDefaultCity(selectCity));
			dispatch(handleToggleCityChangeModalAlert());
		}
		if (emailClient.length > 0 && loadClient) {
			trigger();
		}
	}, [selectCity]);

	useEffect(() => {
		const isDepartamentPlaceholder = Object.values(language).some(
			(lang: any) => lang["province"] === selectedDepartament
		);
		if (isDepartamentPlaceholder) {
			setSelectedDepartament(language[homeState.default_language]["province"]);
		}
		if (selectCity.codigoDane === 0) {
			setSelectCity((prev: any) => ({
				...prev,
				departamento: language[homeState.default_language]["province"],
			}));
		}
	}, [homeState.default_language]);

	const loadCountries = () => {
		if (selectCountry.length === 0) {
			let countriesArray = countryState.countries;
			if (
				countriesArray.length > 0 &&
				countriesArray[0].id !== language[homeState.default_language]["country"]
			) {
				countriesArray.unshift({
					id: language[homeState.default_language]["country"],
					name: language[homeState.default_language]["country"],
					title: language[homeState.default_language]["country"],
				});
			}

			countries.current = countriesArray.map((el: any) => (
				<option key={`${el.id}${uuid()}`} value={el.name}>
					{el.title}
				</option>
			));

			setSelectCountry(countries.current);
		}
	};

	const handleMappingOptionDeparment = (departamentsArray: any) => {
		if (
			departamentsArray.length > 0 &&
			departamentsArray[0].value !== language[homeState.default_language]['inputSelect']
		) {
			departamentsArray.unshift({
				value: language[homeState.default_language]['inputSelect'],
				name: language[homeState.default_language]['inputSelect'],
			});
		}
		departaments.current = departamentsArray.map((el: any) => (
			<option key={`${el.value}${uuid()}`}>{formatNameCity(el.name)}</option>
		));
		setSelecDepartament(departaments.current);
	};

	const handleMappingOptionCity = (citiesArray: any) => {
		if (
			citiesArray.length > 0 &&
			citiesArray[0].nombre !== language[homeState.default_language]["city"]
		) {
			citiesArray.unshift({
				codigo_dane: 0,
				nombre: language[homeState.default_language]["city"],
				departamento: selectedDepartament,
			});
		}
		cities.current = citiesArray
			.filter(
				(filter: any) =>
					filter.departamento.toUpperCase() ===
					selectedDepartament.toUpperCase()
			)
			.map((el: any) => {
				return (
					<option value={el.codigo_dane} key={`${el.codigo_dane}${uuid()}`}>
						{formatNameCity(el.nombre)}
					</option>
				);
			});
		setSelCity(cities.current);
	};

	useEffect(() => {
		loadCountries();
		let departamentsArray = cityState.cities.map(
			(item: any) => item.departmentName?.trim()
		);
		departamentsArray = departamentsArray
			.filter(
				(value: any, index: any, self: any) => self.indexOf(value) === index
			)
			.map((el: any) => {
				return {
					value: el,
					name: el,
				};
			});
		handleMappingOptionDeparment(departamentsArray);

		if (!isAveonlineIntegration) {
			const citiesArray = cityState.cities.map((item: any) => ({
				...item,
				codigo_dane: item.dane,
				nombre: item.name,
				departamento: item.departmentName?.trim(),
			}));
			handleMappingOptionCity(citiesArray);
		} else if (!(aveonlineState.cities?.length > 0)) {
			setSelCity([
				<option key="city-default" value="">
					{language[homeState.default_language]["inputSelect"]}
				</option>,
			] as any);
		}
	}, [
		countryState.countries,
		cityState.cities,
		selectedDepartament,
		selectCity,
		homeState.default_language,
		isAveonlineIntegration,
	]);

	useEffect(() => {
		if (selectedCountry !== "País") {
			departaments.current = [
				<option key="select-default">
					{language[homeState.default_language]["inputSelect"]}
				</option>,
			];
			setSelecDepartament(departaments.current);
			if (
				(cityState.cities.length > 0 &&
					cityState.cities[0].country_code !== selectedCountry) ||
				cityState.cities.length === 0
			) {
				dispatch(handleGetCities(path, selectedCountry));
			}
		}
	}, [selectedCountry]);

	const loadData = () => {
		if (elogisticaState.departaments.length === 0) {
			dispatch(handleLoadDepartaments());
		}
		if (elogisticaState.cities.length === 0) {
			dispatch(handleLoadCities());
		}
	};

	//End Elogistica services

	useEffect(() => {
		if (shoppingCartState.id !== idCart && idCart !== 0 && idCart !== "empty") {
			dispatch(
				handleIdentifyShoppingCart(
					idCart,
					`${domain}/vende/${homeState.catalogueUrlName}`,
					window.location,
					[],
					homeState.default_language
				)
			);
		}
	}, [dispatch, homeState.catalogueName, idCart]);

	const [authorize, setAuthorize] = useState(false);
	useEffect(() => {
		let productArr = shoppingCartState.cartInfo;
		if (
			productArr.filter(
				(product: any) => product.productData.epaycoDeliveryProvider === true
			).length > 0
		) {
			setProductHasProvider(true);
		} else {
			setProductHasProvider(false);
		}
		setAuthorize(shippingDetailsState.saveInfoShipping);
	}, [shoppingCartState.cartInfo]);

	const handleAuthorizeChange = () => {
		if (loadClient) {
			trigger();
			if (!authorize) {
				const formData = {
					...getFormValues(),
					departament: selectedDepartament,
					cityCode: selectCity.codigoDane,
					cityName: selectCity.nombre,
					country: selectedCountry,
					isAveonline: true
				};
			}
			dispatch(
				termsConditions({
					terms: false,
					conditions: false,
					saveInfoShipping: !authorize,
				})
			);
			setAuthorize((prev) => !prev);
		}
	};

	const validaEmail = (value: string) => {
		let emailRegex =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return emailRegex.test(value);
	};

	const handleNextStep = async () => {

		trigger().then(()=>{
			setHasSubmitted(true);
			let isValid = getIsDisabledPaymentButton();

			if(isValid)
			{
				nextStep();

			}
		});
	};

	const handlePreviousStep = async () => {
		previousStep();
	};

	const handleSearchClient = async (emailClient: string) => {
		if (emailClient.length > 0 && validaEmail(emailClient)) {
			setLoadClient(true);
			dispatch(handleResetDetails());
			dispatch(handleLoadingInfo(true));

			dispatch(handleSearchBuyer(emailClient, path, catalogueId));
		}
	};

	const showError = (field: string) => {
		const clientDetailsLoaded = shippingDetailsState.loading;

		if (field === "departament") {
			return (
				!clientDetailsLoaded &&
				((selectedDepartament.length === 0) ||
					(selectedDepartament === "Departamento") ||
					(selectedDepartament === "Selecciona..."))
			);
		}
		if (field === "city") {
			return !clientDetailsLoaded && (selectCity.codigoDane === 0 || (selectCity.codigoDane as any) === '' || selectCity.nombre === "" || selectCity.nombre === language[homeState.default_language]["inputSelect"]|| selectCity.nombre === language[homeState.default_language]["city"]);
		}

		return false;
	};

	const getIsDisabledPaymentButton = () => {
		const formValues = getFormValues();
		const hasErrorDepartament = showError("departament");
		const hasErrorCity = showError("city");
		const hasErrorPhone = formValues.phone ? formValues.phone.length < 10 : true;
		const hasErrorTipoVia = !formValues.streetType;
		const hasErrorNombreVia = !formValues.streetName;
		const hasErrorNumero = !formValues.streetNumber;
		const hasErrorNumero2 = !formValues.crossNumber;
		const hasErrorTipoVivienda = !formValues.housingType;
		const hasErrorDetalleUbicacion = !formValues.locationDetail;
		const currentDocType = formValues.documentType || '';
		const hasErrorDocumentType = !currentDocType;
		const docNum = formValues.documentNumber || '';
		const hasErrorDocumentNumber = docNum.length < 6 || (currentDocType === 'NIT' ? !/^[0-9]+-[0-9]$/.test(docNum) : !/^[0-9]+$/.test(docNum));

		const hasErrorName = !formValues.name;
		const hasErrorLastname = !formValues.lastname;

		return (
			!(hasErrorName ||
			hasErrorLastname ||
			hasErrorTipoVia ||
			hasErrorNombreVia ||
			hasErrorNumero ||
			hasErrorNumero2 ||
			hasErrorTipoVivienda ||
			hasErrorDetalleUbicacion ||
			hasErrorPhone ||
			hasErrorDepartament ||
			hasErrorCity ||
			hasErrorDocumentType ||
			hasErrorDocumentNumber
			));
	};

	useEffect(() => {
		const deptRaw = shippingDetailsState.departamentoAveonline || shippingDetailsState.departament;
		const dept = deptRaw === "Bogotá DC" ? "Bogotá Dc" : deptRaw;
		setSelectedDepartament(dept);
		setValue("departament", deptRaw);

		const cityName = shippingDetailsState.municipioAveonline || shippingDetailsState.city;
		setSelectCity({
			codigoDane: shippingDetailsState.codeDane || '',
			nombre: cityName,
			departamento: deptRaw,
		});
		setCityName(cityName);

		if (isAveonlineIntegration && dept && dept !== "" && dept !== "Selecciona..." && dept !== language[homeState.default_language]["province"]) {
			dispatch(handleGetCitiesAveonline(dept, path));
		}

		setValue("streetType", shippingDetailsState.streetType || '');
		setValue("streetName", shippingDetailsState.streetName || '');
		setValue("streetNumber", shippingDetailsState.streetNumber || '');
		setValue("crossNumber", shippingDetailsState.crossNumber || '');
		setValue("housingType", shippingDetailsState.housingType || '');
		setValue("locationDetail", shippingDetailsState.locationDetail || '');
		setValue("additionalAddress", shippingDetailsState.additionalAddress || '');
		setValue("documentType", shippingDetailsState.documentType || '');
		setValue("documentNumber", shippingDetailsState.documentNumber || shippingDetailsState.documentId || '');
		if (shippingDetailsState.documentType) {
				setTipoDocumento(shippingDetailsState.documentType);
		}
	}, [shippingDetailsState.documentId]);

	return (
		<AddresInfoContainer showModal={showModal}>
			<div className={"address-info-container"}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<MainHeadingForm>
						<TitleSummaryCart
							color={homeState.color}
							isEmpty={shoppingCartState.cartInfo.length <= 0}
						>
							{language[homeState.default_language]["infoContact"]}
						</TitleSummaryCart>
					</MainHeadingForm>
					<FormContainer>
						<div></div>
						<SecondParragraph color={homeState.color} opacity={false}>
							<span>1</span>
							{language[homeState.default_language]["inputEmail"]}
						</SecondParragraph>

						<ContainerInputEmail widthProps={!loadClient ? "80%" : "100%"}>
							<div>
								<StyledTextField
									variant="outlined"
									placeholder="example@email.com"
									key="email"
									value={emailClient}
									loadClient={loadClient}
									disabled={loadClient}
									onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
										setEmailClient(event.target.value);
										setLoadClient(false);
									}}
									InputProps={{
										inputProps: {
											"data-testid": "input",
										},
										startAdornment: (
											<InputAdornment position="start" key="userIcon">
												<AccountCircle htmlColor={homeState.color} />
											</InputAdornment>
										),
										endAdornment: (
											<>
												{loadClient ? (
													<InputAdornment position="end" key="editIcon">
														<EditOutlinedIcon
															htmlColor={homeState.color}
															style={{ cursor: "pointer" }}
															onClick={() => setLoadClient(false)}
														/>
													</InputAdornment>
												) : (
													<></>
												)}
											</>
										),
									}}
								/>
							</div>
							{!loadClient && (
								<div>
									<StyledButton
										variant="contained"
										key="buttomEmail"
										disableElevation
										onClick={() => handleSearchClient(emailClient)}
										disabled={!validaEmail(emailClient)}
									>
										{language[homeState.default_language]["continue"]}
									</StyledButton>
								</div>
							)}
						</ContainerInputEmail>

						<SecondParragraph color={homeState.color} opacity={!loadClient}>
							<span>2</span>
							{language[homeState.default_language]["completedInfo"]}
						</SecondParragraph>
						{shippingDetailsState.loading ? (
							<LoadContainer>
								<Spinner color={homeState.color} />
							</LoadContainer>
						) : (
							<>
								{/* Nombres y Apellidos */}
								<SecondDivForm>
									<div style={{ flex: 1, marginRight: isMobile ? 0 : 30 }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveFirstNameLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												loadClient && errors.name
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder={language[homeState.default_language]["nameAveonline"]}
											name="name"
											maxLength={40}
											onKeyDown={handleNameInput}
											onChange={() => trigger("name")}
											defaultValue={
												shippingDetailsState?.firstName ||
												shoppingCartState.contactName ||
												""
											}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												pattern: /^[A-Za-z áéíóúü]+$/i,
											})}
										/>
										{loadClient && errors.name && (
											<span style={{ display: "flex" }} className="fontSizeSmall">
												{language[homeState.default_language]["inputName"]}
											</span>
										)}
									</div>

									<div style={{ flex: 1 }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveLastNameLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												loadClient && errors.lastname
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder={
												language[homeState.default_language]["nameAveonline"]
											}
											name="lastname"
											maxLength={60}
											onKeyDown={handleNameInput}
											onChange={() => trigger("lastname")}
											defaultValue={
												shippingDetailsState?.lastName ||
												shoppingCartState.contactLastname ||
												""
											}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												pattern: /^[A-Za-z áéíóúü]+$/i,
											})}
										/>
										{loadClient && errors.lastname && (
											<span style={{ display: "flex" }} className="fontSizeSmall">
												{language[homeState.default_language]["inputLastname"]}
											</span>
										)}
									</div>
								</SecondDivForm>
								{/* Tipo de documento y Número de documento */}
								<SecondDivForm>
										<div style={{ flex: 1, marginRight: isMobile ? 0 : 30 }}>
												<label style={{ ...labelStyle, marginTop: "20px" }}>{language[homeState.default_language]["typeDocumentLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
												<FirstSelectForm
														style={{ width: "100%", ...inputStyle }}
														color={
																hasSubmitted && errors.documentType
																		? "#ff0000"
																		: width > 992
																		? "#c4c4c4"
																		: colorEmptyErrors
														}
														name="documentType"
														disabled={!loadClient}
														ref={register({ required: true })}
														value={tipoDocumento}
														onChange={(e: any) => {
																setTipoDocumento(e.target.value);
																trigger("documentType");
																trigger("documentNumber");
														}}
												>
														<option value="">{language[homeState.default_language]["inputSelect"]}</option>
														{documentTypes.map((dt) => (
																<option key={dt.id} value={dt.code}>{dt.name}</option>
														))}
												</FirstSelectForm>
										</div>
										<div style={{ flex: 1 }}>
												<label style={{ ...labelStyle, marginTop: "20px" }}>{language[homeState.default_language]["documentNumberLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
												<NameInput
														style={{ width: "100%", marginRight: 0, ...inputStyle }}
														color={
																hasSubmitted && errors.documentNumber
																		? "#ff0000"
																		: width > 992
																		? "#c4c4c4"
																		: colorEmptyErrors
														}
														placeholder={language[homeState.default_language]["nameAveonline"]}
														name="documentNumber"
														maxLength={15}
														onKeyDown={handleDocumentInput}
														onChange={() => trigger("documentNumber")}
														defaultValue={shippingDetailsState?.documentNumber || shippingDetailsState?.documentId || ''}
														disabled={!loadClient}
														ref={register({
																required: true,
																minLength: 6,
																maxLength: 15,
																validate: (value: string) => {
																		const currentDocType = getFormValues().documentType;
																		if (currentDocType === 'NIT') {
																			return /^[0-9]+-[0-9]$/.test(value) || language[homeState.default_language]["documentNit"];
																		}
																		return /^[0-9]+$/.test(value) || language[homeState.default_language]["documentNumber"];
																},
														})}
												/>
										</div>
								</SecondDivForm>
								<DivForSpan1>
										{hasSubmitted && errors.documentType && isMobile && (
												<span style={{ display: "flex" }} className="fontSizeSmall">
														{language[homeState.default_language]["documentTypeRequired"]}
												</span>
										)}
										{hasSubmitted && errors.documentType && !isMobile && (
												<SpanOne className="fontSizeSmall">
														{language[homeState.default_language]["documentTypeRequired"]}
												</SpanOne>
										)}
										{!errors.documentType && !isMobile && (
												<SpanOne>&nbsp;</SpanOne>
										)}
										{hasSubmitted && errors.documentNumber && isMobile && (
												<span style={{ display: "flex" }} className="fontSizeSmall">
														{errors.documentNumber.type === 'minLength'
																? language[homeState.default_language]["minLenDocument"]
																: errors.documentNumber.type === 'validate'
																? errors.documentNumber.message
																: language[homeState.default_language]["documentNumberRequired"]}
												</span>
										)}
										{hasSubmitted && errors.documentNumber && !isMobile && (
												<SpanTwo className="fontSizeSmall">
														{errors.documentNumber.type === 'minLength'
																? language[homeState.default_language]["minLenDocument"]
																: errors.documentNumber.type === 'validate'
																? errors.documentNumber.message
																: language[homeState.default_language]["documentNumberRequired"]}
												</SpanTwo>
										)}
								</DivForSpan1>

								{/* País */}
								<label style={{ ...labelStyle, marginTop: "20px" }}>
									{language[homeState.default_language]["country"]}
									<span style={{ color: "#E11417" }}>*</span>
								</label>
								<FirstSelectForm
									style={{ width: "100%", ...inputStyle }}
									color={
										hasSubmitted && errors.country
											? "#ff0000"
											: width > 992
											? "#c4c4c4"
											: colorEmptyErrors
									}
									name="country"
									disabled={!loadClient || productHasProvider || isAveonlineIntegration}
									ref={register({ required: true })}
									value={productHasProvider ? "CO" : selectedCountry}
									defaultValue={shippingDetailsState?.country}
									onChange={(e) => {
										if (!productHasProvider) {
											trigger("country");
											setSelectedCountry(e.target.value);
											const nameCountry = countryState.countries.find(
												(itemContry: any) => itemContry.name === e.target.value
											);
											setCountryName(nameCountry ? nameCountry.title : "");
											setSelectedDepartament(
												language[homeState.default_language]["province"]
											);
											setSelectCity({
												codigoDane: 0,
												nombre: language[homeState.default_language]["city"],
												departamento: language[homeState.default_language]["province"],
											});
										}
									}}
								>
									{selectCountry}
								</FirstSelectForm>

								{/* Departamento y Municipio */}
								<SecondDivForm>
									<div style={{ flex: 1, marginRight: isMobile ? 0 : 30 }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveDepartmentLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<FirstSelectForm
											style={{ width: "100%", ...inputStyle }}
											color={
												hasSubmitted && showError("departament")
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										name="departament"
										disabled={!loadClient}
										ref={register({
											required: true,
										})}
										value={selectedDepartament}
										defaultValue={shippingDetailsState?.departament}
										onChange={(e) => {
											trigger("departament");
											if (
												e.target.value ===
												language[homeState.default_language]["province"]
											) {
												setSelectedDepartament(
													formatNameCity(
														elogisticaState.selectedCity.departamento
													)
												);
												changeCity(elogisticaState.selectedCity.codigoDane);
											} else {
												setSelectedDepartament(e.target.value);
												if (isAveonlineIntegration) {
													dispatch(handleGetCitiesAveonline(e.target.value, path));
												}
												setSelectCity({
													codigoDane: 0,
													nombre: "",
													departamento:
														language[homeState.default_language]["province"],
												});
											}
										}}
									>
										{selecDepartament}
									</FirstSelectForm>
									</div>
									<div style={{ flex: 1 }}>
									<label style={labelStyle}>{language[homeState.default_language]["aveProvinceLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
									<SecondSelectForm
										style={{ width: "100%", marginLeft: 0, ...inputStyle }}
										color={
											hasSubmitted && showError("city")
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										name="city"
										disabled={!loadClient}
										ref={register({
											required: true,
										})}
										onChange={(e) => {
											trigger();
											const selectedValue = e.target.value;
											const aveonlineCity = aveonlineState.cities?.find(
												(item: any) => item.nombre === selectedValue
											);
											if (aveonlineCity) {
												setCityName(formatNameCity(aveonlineCity.nombre));
												setSelectCity({
													codigoDane: aveonlineCity.codigoDANE,
													nombre: aveonlineCity.nombre,
													departamento: selectedDepartament,
												});
												setValue("cityDane", aveonlineCity.codigoDANE);
											} else if (productHasProvider) {
												setCityName(
													elogisticaState.cities.find(
														(item: any) => item.dane == selectedValue
													)?.nombre
												);
												changeCity(selectedValue);
											} else {
												setCityName(
													cityState.cities.find(
														(item: any) => item.dane == selectedValue
													)?.name
												);
												changeCity(selectedValue);
											}
											if (productHasProvider) {
												setAlertShipping(true);
											}
										}}
										defaultValue={shippingDetailsState.codeDane}
										value={aveonlineState.cities?.length > 0 ? selectCity.nombre : selectCity.codigoDane}
									>
										{selCity}
									</SecondSelectForm>
									<input type="hidden" name="cityDane" ref={register()} />
									</div>
								</SecondDivForm>

								<DivForSpan1>
									{hasSubmitted && showError("departament") && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["selectedProvince"]}
										</span>
									)}
									{hasSubmitted && showError("departament") && !isMobile && (
										<SpanOne className="fontSizeSmall">
											{language[homeState.default_language]["selectedProvince"]}
										</SpanOne>
									)}
									{!showError("departament") && !isMobile && (
										<SpanOne>&nbsp;</SpanOne>
									)}
									{hasSubmitted && showError("city") && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["seletedCity"]}
										</span>
									)}
									{hasSubmitted && showError("city") && !isMobile && (
										<SpanTwo className="fontSizeSmall">
											{language[homeState.default_language]["seletedCity"]}
										</SpanTwo>
									)}
								</DivForSpan1>

								{/* Tipo de vía, Nombre/número de la vía y Número */}
								<div style={{ marginTop: 20, display: "flex", flexDirection: isMobile ? "column" : "row", gap: 10 }}>
									<div style={{ flex: isMobile ? "unset" : 7, minWidth: 0, width: isMobile ? "100%" : "auto" }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveTypeOfRoadLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<FirstSelectForm
											style={{ width: "100%", ...inputStyle }}
											color={
												hasSubmitted && errors.streetType
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											name="streetType"
											disabled={!loadClient}
											ref={register({
												required: true,
											})}
											defaultValue={shippingDetailsState?.streetType || ''}
											onChange={() => trigger("streetType")}
										>
											{TIPOS_VIA(language[homeState.default_language]).map((tipo, index) => (
												<option key={`streetType-${index}`} value={tipo.value}>
													{tipo.label}
												</option>
											))}
										</FirstSelectForm>
									</div>
									<div style={{ flex: isMobile ? "unset" : 7, minWidth: 0, width: isMobile ? "100%" : "auto" }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveNameOrNumberOfRoadLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												hasSubmitted && errors.streetName
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder={language[homeState.default_language]["aveNameOrNumberOfRoadLabel"]}
											name="streetName"
											maxLength={20}
											onChange={() => trigger("streetName")}
											defaultValue={shippingDetailsState?.streetName || ''}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												maxLength: 20,
											})}
										/>
									</div>
									<div style={{ flex: isMobile ? "unset" : 3, minWidth: 0, width: isMobile ? "100%" : "auto" }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveNumberLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												hasSubmitted && errors.streetNumber
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder="#"
											name="streetNumber"
											maxLength={6}
											onChange={() => trigger("streetNumber")}
											defaultValue={shippingDetailsState?.streetNumber || ''}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												maxLength: 6,
											})}
										/>
									</div>
									<div style={{ flex: isMobile ? "unset" : 3, minWidth: 0, width: isMobile ? "100%" : "auto" }}>
										{!isMobile && <label style={{ ...labelStyle, visibility: "hidden" }}>-</label>}
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												hasSubmitted && errors.crossNumber
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder={language[homeState.default_language]["nameAveonline"]}
											name="crossNumber"
											maxLength={6}
											onChange={() => trigger("crossNumber")}
											defaultValue={shippingDetailsState?.crossNumber || ''}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												maxLength: 6,
											})}
										/>
									</div>
								</div>
								<div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 10 }}>
									{hasSubmitted && errors.streetType && (
										<span style={{ flex: 1, display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveTypeOfRoadError"]}
										</span>
									)}
									{!errors.streetType && !isMobile && (
										<span style={{ flex: 1 }}>&nbsp;</span>
									)}
									{hasSubmitted && errors.streetName && (
										<span style={{ flex: 1, display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveNameOrNumberOfRoadError"]}
										</span>
									)}
									{!errors.streetName && !isMobile && (
										<span style={{ flex: 1 }}>&nbsp;</span>
									)}
									{hasSubmitted && errors.streetNumber && (
										<span style={{ flex: 1, display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveNumber1Error"]}
										</span>
									)}
									{!errors.streetNumber && !isMobile && (
										<span style={{ flex: 1 }}>&nbsp;</span>
									)}
									{hasSubmitted && errors.crossNumber && (
										<span style={{ flex: 1, display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveNumber2Error"]}
										</span>
									)}
									{!errors.crossNumber && !isMobile && (
										<span style={{ flex: 1 }}>&nbsp;</span>
									)}
								</div>

								{/* Tipo de vivienda y Detalle de la ubicación */}
								<SecondDivForm>
									<div style={{ flex: 1, marginRight: isMobile ? 0 : 30 }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveTypeOfResidenceLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<FirstSelectForm
											style={{ width: "100%", ...inputStyle }}
											color={
												hasSubmitted && errors.housingType
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											name="housingType"
											disabled={!loadClient}
											ref={register({
												required: true,
											})}
											defaultValue={shippingDetailsState?.housingType || ''}
											onChange={() => trigger("housingType")}
										>
											{TIPOS_VIVIENDA(language[homeState.default_language]).map((tipo, index) => (
												<option key={`housingType-${index}`} value={tipo.value}>
													{tipo.label}
												</option>
											))}
										</FirstSelectForm>
									</div>
									<div style={{ flex: 1 }}>
										<label style={labelStyle}>{language[homeState.default_language]["aveUbicationDetailsLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
										<NameInput
											style={{ width: "100%", marginRight: 0, ...inputStyle }}
											color={
												hasSubmitted && errors.locationDetail
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											placeholder={language[homeState.default_language]["aveUbicationDetailsExampleLabel"]}
											name="locationDetail"
											maxLength={40}
											onChange={() => trigger("locationDetail")}
											defaultValue={shippingDetailsState?.locationDetail || ''}
											disabled={!loadClient}
											ref={register({
												required: true,
												minLength: 1,
												maxLength: 40,
											})}
										/>
									</div>
								</SecondDivForm>
								<DivForSpan1>
									{hasSubmitted && errors.housingType && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveTypeOfResidenceError"]}
										</span>
									)}
									{hasSubmitted && errors.housingType && !isMobile && (
										<SpanOne className="fontSizeSmall">
											{language[homeState.default_language]["aveTypeOfResidenceError"]}
										</SpanOne>
									)}
									{!errors.housingType && !isMobile && (
										<SpanOne>&nbsp;</SpanOne>
									)}
									{hasSubmitted && errors.locationDetail && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["aveUbicationDetailsError"]}
										</span>
									)}
									{hasSubmitted && errors.locationDetail && !isMobile && (
										<SpanTwo className="fontSizeSmall">
											{language[homeState.default_language]["aveUbicationDetailsError"]}
										</SpanTwo>
									)}
								</DivForSpan1>

								{/* Teléfono (celular) */}
								<label style={{ ...labelStyle, marginTop: "20px" }}>{language[homeState.default_language]["avePhoneLabel"]}<span style={{ color: "#E11417" }}>*</span></label>
								<PhoneInput
									style={{ ...inputStyle, marginTop: 5 }}
									color={
										loadClient && errors.phone && hasSubmitted
											? "#ff0000"
											: width > 992
											? "#c4c4c4"
											: colorEmptyErrors
									}
									placeholder={language[homeState.default_language]["nameAveonline"]}
									name="phone"
									maxLength={15}
									onKeyDown={handlePhoneInput}
									onChange={() => {
										trigger();
									}}
									defaultValue={
										shippingDetailsState?.phone ||
										shoppingCartState?.contactPhone ||
										""
									}
									disabled={!loadClient}
									ref={register({
										required: true,
										minLength: 10,
										maxLength: 15,
										pattern: /^([0-9]*)$/i,
									})}
								/>
								{loadClient && errors.phone && isMobile && hasSubmitted && (
									<span style={{ display: "flex" }} className="fontSizeSmall">
										{language[homeState.default_language]["phoneInvalid"]}
									</span>
								)}
								{ errors.phone && !isMobile && hasSubmitted && (
									<SpanOne className="fontSizeSmall">
										{language[homeState.default_language]["phoneInvalid"]}
									</SpanOne>
								)}

								{/* Dirección más específica (opcional) */}
								<label style={{ ...labelStyle, marginTop: "40px", marginBottom: "2px" }}>{language[homeState.default_language]["aditionalAddress"]}</label>
								<DetailsTextArea
									style={{ height: "131px" }}
									name="additionalAddress"
									maxLength={150}
									className={"noError"}
									placeholder={language[homeState.default_language]["nameAveonline"]}
									onChange={() => trigger("additionalAddress")}
									disabled={!loadClient}
									color={width > 992 ? "#c4c4c4" : colorEmptyErrors}
									defaultValue={shippingDetailsState?.additionalAddress || ''}
									ref={register({
										minLength: 1,
										maxLength: 150,
									})}
								/>

								<ContainerAuthorize disabled={!loadClient}>
									<Checkbox
										checked={authorize}
										color={homeState.color}
										onChange={handleAuthorizeChange}
										disabled={!loadClient}
									/>
									<label>
										{language[homeState.default_language]["saveInfo"]}
									</label>
								</ContainerAuthorize>
								<ContainerNote>
									<InfoIcon htmlColor="#40A8E6" />
									<p>
										{
											language[homeState.default_language][
												"messageAuthorizationAveonline"
											]
										}
									</p>
								</ContainerNote>
							</>
						)}
					</FormContainer>
				</form>

				{!shippingDetailsState.loading && (
					<div className="shipping-info_footer-buttons">
						<ReturnLinkContainer className="return-link-container">
							<a
								style={{ cursor: "pointer", color: `${homeState.color}` }}
								onClick={() => handlePreviousStep()}
								className="return-link"
							>
								<ChevronLeftIcon style={{ color: `${homeState.color}` }} />{" "}
								{language[homeState.default_language]["back"]}
							</a>
						</ReturnLinkContainer>

						<div className="shipping-info__pay-button-container">
							<CartPaymentButton
								color={color}
								loading={false}
								onClick={handleNextStep}
								disabled={!getIsDisabledPaymentButton() || !loadClient}
							>
								{language[homeState.default_language]["continue"]}
							</CartPaymentButton>
							<AddMoreProducts
								language={
									language[homeState.default_language]["addMoreProducts"]
								}
								onClick={() =>
									history.push(`/vende/${homeState.catalogueUrlName}/categories`)
								}
							/>
						</div>
					</div>
				)}
			</div>
		</AddresInfoContainer>
	);
};

export default AddressInfoAveonline;
